export class PositionedImage {
  public bitmap: ImageBitmap | undefined;
  constructor(
    public url: string,
    public height = 100,
    public width = 100,
    public x = 0,
    public y = 0,
    public preserveAspect = true
  ) {}

  load = async () => {
    try {
      const response = await fetch(this.url);
      const imgBlob = await response.blob();
      this.bitmap = await createImageBitmap(imgBlob);
      const aspectRatio = this.bitmap.width / this.bitmap.height;
      const targetAspectRatio = this.width / this.height;

      // will stretch image width to fit height
      if (this.preserveAspect) {
        const scale =
          targetAspectRatio < aspectRatio ? this.height / this.bitmap.height : this.width / this.bitmap.width;
        this.width = this.bitmap.width * scale;
        this.height = this.bitmap.height * scale;
      }
    } catch (e) {
      console.error(e);
    }
  };
}
